/* eslint-disable import/prefer-default-export */
import { ENGINES } from '../../gameFactory.types';
import { getLogger } from '../../logging/logger';
import { promisify } from '../../util/utilities';
import { ATTRIBUTES } from '../baseGame.types';
import AdventGame, { EVENTS } from './adventGame';

const Logger = getLogger('AdventLeaderboardUtils');

/**
 * A utility to be used with leaderboards that contain an advent game. It replaces the advent
 * game data for all of it's unlocked nodes games.
 *
 * @param {import('../baseGameView').BaseGameViewOptions} leaderboardData
 * @return {Promise<any>}
 */
export function leaderboardAdventToNodeGames(leaderboardData) {
	Logger.log(`[${leaderboardAdventToNodeGames.name}]`, { leaderboardData });

	const { pages = [] } = leaderboardData;

	return pages.reduce((prevPromise, page, index) => {
		const { [ATTRIBUTES.type]: type, [ATTRIBUTES.leaderboard]: leaderboard = {} } = page;
		const isAdvent = type === ENGINES.advent;
		const { useNodeLeaderboards } = leaderboard;

		if (isAdvent && useNodeLeaderboards) {
			return prevPromise
				.then(() => promisify(new AdventGame(page), EVENTS.initialized))
				.then((/** @type {AdventGame} */ adventGame) => {
					pages.splice(index, 1, ...adventGame.getUnlockedNodeGameData());
				});
		}

		return prevPromise;
	}, Promise.resolve());
}
